export default function formatRuleViolationMessage(
  message: string,
  parameterNames: string[],
  violationData: Record<string, any>,
): string {
  const parameters = parameterNames.map((paramName) => violationData[paramName] ?? '');
  return message.replace(/%[^ ]+/g, () => `<u>${parameters.shift() ?? ''}</u>`);
}
